import Link from "next/link";
import ExtraPageFooter from "../../components/Common/ExtraPageFooter";
import FeaturedArticlesComponent from "../../components/Common/FeaturedArticlesComponent";
import PageHeadingComponent from "../../components/Common/PageHeadingComponent";
import RecentArticles from "../../components/Common/RecentArticles";
import Footer from "../../components/_App/Footer";
import Header from "../../components/_App/Header";
import apiClient from "../../data/apiClient";
import { ARTICLE_LIST_QUERY } from "../../data/pageQuery";

const Articles = ({ data, footer, menu }) => {
  const headingData = { heading: "Featured Articles" };
  const recentPost = { heading: "Recent Posts" };

  return (
    <>
      <Header {...menu} />
      <div className='w-100 d-flex bg-light py-md-4 py-3'>
        <nav className='container' aria-label='breadcrumb'>
          <ol className='breadcrumb mb-0'>
            <li className='breadcrumb-item'>
              <Link href='/' legacyBehavior>
                <a>Home</a>
              </Link>
            </li>
            <li className='breadcrumb-item d-block d-md-none'>
              <Link href='/' legacyBehavior>
                <a>...</a>
              </Link>
            </li>
            <li className='breadcrumb-item active' aria-current='page'>
              Articles
            </li>
          </ol>
        </nav>
      </div>
      <div>
        <PageHeadingComponent {...headingData} />
        <FeaturedArticlesComponent items={data} />
        <PageHeadingComponent {...recentPost} />
        <RecentArticles items={data} />
      </div>
      <ExtraPageFooter />
      <Footer {...footer} />
    </>
  );
};

export async function getStaticProps() {
  const isAU = process.env.NEXT_PUBLIC_SITE_IS_AU == "true";
  const filter = isAU ? "data/isAU/iv eq true" : "data/isNZ/iv eq true";
  const { data } = await(await apiClient()).query({
    query: ARTICLE_LIST_QUERY,
    variables: { filter: filter },
    fetchPolicy: "no-cache",
  });

  const {
    queryArticleContents: articleContents,
    queryFooterContents: footerContents,
    queryMenuContents: menuContents,
  } = data;
  const articleContent = articleContents;
  const footerContent =
    footerContents[0] != null ? footerContents[0].flatData : [];
  const menuContent = menuContents[0] != null ? menuContents[0].flatData : [];

  return {
    props: {
      data: articleContent,
      footer: footerContent,
      menu: menuContent,
      seo: {
        title:
          "Articles | Ryco Filters | Air Filters, Oil Filters and Fuel Filters | Automotive Filters",
        metadata: "Read Latest Ryco Filters Articles",
        keywords: "Ryco Filters, Articles, Blog, Published",
        socialTitle: `Ryco Filters Articles`,
        isNzOnly: false,
        url: "/articles",
      },
    },
    revalidate: 60 * 1, // in seconds
  };
}

export default Articles;
